import { Alert, DialogConfirm, Loading } from '@components/commons';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { muiTheme } from '@styles/MuiTheme';
import moment from 'moment';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { BrowserRouter as Router } from 'react-router-dom';
import './App.css';
import AppRoutes from './AppRoutes';
import GlobalStyles from './styles/GlobalStyles/GlobalStyles';
import './styles/bases/_index.scss';
import './styles/utils/_index.scss';

function App() {
  const { i18n } = useTranslation();

  useEffect(() => {
    moment.locale(i18n.language);
  }, [i18n.language]);

  return (
    <div className="App">
      <Router>
        <ThemeProvider theme={muiTheme}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <GlobalStyles>
              <AppRoutes />
              <DialogConfirm />
              <Alert />
              <Loading />
            </GlobalStyles>
          </LocalizationProvider>
        </ThemeProvider>
      </Router>
    </div>
  );
}

export default App;
